export const LEGISLATIVE_CATEGORY_ID = 'legislative';
export const TOUR_STORAGE_KEY = 'cityExplorer:legislativeMapTour:v1';
export const DATA_SOURCES_STEP_INDEX = 4;

export const stepsWithoutDataSources = (steps = []) =>
  steps.filter((step) => step.id !== 'data-sources');

export const dataSourcesStepIndex = (steps = []) =>
  steps.findIndex((step) => step.id === 'data-sources');

export const TOUR_STEPS = [
  {
    id: 'shading',
    title: 'District shading',
    body: 'Districts are colored by projected K–12 child population change from 2025 to 2030. Red means decline, gray is roughly flat, and green means growth. The scale is in the legend at the lower left of the map.',
    spotlight: 'legend-strip',
  },
  {
    id: 'hover-zoom',
    title: 'Hover and zoom',
    body: 'Hover a district to see its details. Use the + and − buttons in the top left to zoom, or scroll or pinch. Click a district in the left legend to fly there.',
    spotlight: 'map-zoom',
    spotlightLabel: 'Zoom',
  },
  {
    id: 'school-popups',
    title: 'School details',
    body: 'Click a school marker to open a pop-up with enrollment, grades, and which legislative districts it belongs to. The highlighted card is an example of what you will see.',
    spotlight: 'example-popup',
  },
  {
    id: 'school-markers',
    title: 'School markers',
    body: 'Filled circles are charter schools; squares are district schools. A marker’s fill color matches the school’s legislative district — not the red-to-green growth scale, and not a quality rating.',
    spotlight: 'map-schools-west',
    spotlightLabel: 'Circles and squares',
  },
  {
    id: 'data-sources',
    title: 'Data sources',
    body: 'Methodology notes and the spreadsheets behind this map are in the left panel under Data Sources and Documentation, next to Data Sets.',
    cardAlign: 'bottom-left',
  },
];

export const locationHasLegislativeMaps = (categories = []) =>
  categories.some((category) => category?.id === LEGISLATIVE_CATEGORY_ID);

export const isLegislativeMapItem = (item) =>
  item?.type === 'map' && item.category?.id === LEGISLATIVE_CATEGORY_ID;

// The combined House+Senate export has no left-side legend, so the tour only
// applies to the individual chamber maps. File ids from the share package:
// state_house_districts_map, state_senate_districts_map, legislative_districts.
const legislativeFileRank = (file) => {
  const id = String(file?.id || '').toLowerCase();
  if (id.includes('house')) return 0;
  if (id.includes('senate')) return 1;
  return 2;
};

export const isIndividualLegislativeFile = (file) => legislativeFileRank(file) < 2;

export const isIndividualLegislativeMap = (item) =>
  isLegislativeMapItem(item) && isIndividualLegislativeFile(item.file);

export const filesForCategory = (category) => {
  const files = category?.files || [];
  if (category?.id !== LEGISLATIVE_CATEGORY_ID) return files;
  return [...files].sort((a, b) => legislativeFileRank(a) - legislativeFileRank(b));
};

export const readTourDismissed = () => {
  try {
    return window.localStorage.getItem(TOUR_STORAGE_KEY) === '1';
  } catch (_err) {
    return false;
  }
};

export const writeTourDismissed = () => {
  try {
    window.localStorage.setItem(TOUR_STORAGE_KEY, '1');
  } catch (_err) {
    // Private browsing or disabled storage should not break the map.
  }
};

export const shouldShowLegislativeTour = ({
  hasLegislativeCategory,
  viewingLegislativeMap,
  mapLoaded,
  isFullscreen,
  dismissed,
  replaying,
}) =>
  Boolean(
    hasLegislativeCategory &&
      viewingLegislativeMap &&
      mapLoaded &&
      !isFullscreen &&
      (!dismissed || replaying)
  );
